import { EditTimeDialog } from '$tablet-app/src/app/components/EditTimeDialog';
import {
  SelectionPanel,
  SelectionPanelProps,
} from '$tablet-app/src/app/components/SelectionPanel';
import { MealType } from '@akin-home/amplify';
import { toggleInList } from '@akin-home/arrays';
import { formatTime } from '@akin-home/dates';
import { getMealTime } from '@akin-home/meals';
import { useState } from 'react';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';
import { TimeButton } from './TimeButton';

export const MealsToPlanView = () => {
  const [editing_time, setEditingTime] = useState<MealType>();

  const meals_to_plan = useMealPreferenceDialogState(
    (state) => state.draft_preferences.meals_to_plan
  );

  const meal_times = useMealPreferenceDialogState(
    (state) => state.draft_preferences.meal_times
  );

  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const onPressMeal = (meal: MealType) =>
    update({ meals_to_plan: toggleInList(meals_to_plan, meal) });

  const onPressTimeButton = (meal_type: MealType) => setEditingTime(meal_type);

  const closeTimeSelect = () => setEditingTime(undefined);

  const onChangeTime = (time: string) => {
    if (editing_time) {
      update({ meal_times: { ...meal_times, [editing_time]: time } });
    }

    closeTimeSelect();
  };

  return (
    <>
      <Container>
        <Row>
          {MEAL_TYPES.map((meal) => (
            <Column key={meal.value}>
              <SelectionPanel
                onPress={onPressMeal}
                selected={meals_to_plan?.includes(meal.value)}
                {...meal}
              />

              {meals_to_plan?.includes(meal.value) ? (
                <TimeButton
                  text={formatTime(getMealTime(meal.value)(meal_times))}
                  meal_type={meal.value}
                  onPress={onPressTimeButton}
                />
              ) : null}
            </Column>
          ))}
        </Row>
      </Container>

      {editing_time ? (
        <EditTimeDialog
          visible
          onClose={closeTimeSelect}
          initial_value={getMealTime(editing_time)(meal_times)}
          onSubmit={onChangeTime}
        />
      ) : null}
    </>
  );
};

export const MEAL_TYPES: SelectionPanelProps<MealType>[] = [
  {
    title: MealType.Breakfast,
    value: MealType.Breakfast,
    icon: 'mug-hot',
    iconColor: '#CF9B07',
    backgroundColor: 'rgba(255, 191, 9, 0.15)',
  },
  {
    title: MealType.Lunch,
    value: MealType.Lunch,
    icon: 'cutlery',
    iconColor: '#FF7B43',
    backgroundColor: '#FFEBE3',
  },
  {
    title: MealType.Dinner,
    value: MealType.Dinner,
    icon: 'bowl-hot',
    iconColor: '#FF4343',
    backgroundColor: 'rgba(255, 67, 67, 0.15)',
  },
  {
    title: MealType.Snack,
    value: MealType.Snack,
    icon: 'apple-whole',
    iconColor: '#059669',
    backgroundColor: 'rgba(3, 96, 67, 0.15)',
  },
];

const Container = styled.View`
  align-items: center;
  gap: 30px;
  padding: 30px;
`;

const Row = styled.View`
  flex-direction: row;
  gap: 30px;
`;

const Column = styled.View`
  gap: 30px;
`;
